import Vue from "vue";
import {postBlob} from "@/plugins/axios";


export function businessIncomeList(params) {
    return Vue.axios({
        url: '/api/business_income/list',
        method: 'get',
        params
    })
}

export function businessIncomeExportList(params) {
    return Vue.axios({
        url: '/api/business_income/export',
        method: 'post',
        data: params
    })
}

/**
 * 商务收入 刷新数据
 * @param params
 * @returns {*}
 */
export function businessIncomeRunScript(params) {
    return Vue.axios({
        url: '/api/business_income/runScript',
        method: 'get',
        params
    })
}

export function ensureIncomeList(params) {
    return Vue.axios({
        url: '/api/ensure_income/list',
        method: 'get',
        params
    })
}

/**
 * 导出汇总
 * @param params
 * @returns {*}
 */
export function ensureIncomeExportList(params) {
    // return Vue.axios({
    //   url: '/api/ensure_income/export',
    //   method: 'post',
    //   data: params
    // })
    return postBlob('/api/ensure_income/export', params)
}

/**
 * 收入汇总V2列表
 * @param params
 * @returns {*}
 */
export function incomeSummaryV2List(params) {
    return Vue.axios({
        url: '/api/income_summary_v2/list',
        method: 'get',
        params
    })
}

/**
 * 收入汇总V2 刷新数据
 * @param params
 * @returns {*}
 */
export function incomeSummaryV2RunScript(params) {
    return Vue.axios({
        url: '/api/income_summary_v2/runScript',
        method: 'get',
        params
    })
}

/**
 * 通知经纪人
 * @param params
 * @returns {*}
 */
export function notifyAgent(params) {
    return Vue.axios({
        url: '/api/income_summary/notify_agent',
        method: 'post',
        data: params
    })
}

/**
 * 确认分成 - 全案保量
 * @param {Object} params - 参数对象
 * @param {Array} params.ids - ID数组
 * @param {String} params.type - 类型 ('ensure' 或 'business')
 * @returns {*}
 */
export function confirmIncome(params) {
    return Vue.axios({
        url: '/api/income_summary/confirm',
        method: 'post',
        data: params
    })
}

/**
 * 确认分成 - 商务收入
 * @param {Object} params - 参数对象
 * @param {Array} params.ids - ID数组
 * @param {String} params.type - 类型 ('ensure' 或 'business')
 * @returns {*}
 */
export function confirmBusinessIncome(params) {
    return Vue.axios({
        url: '/api/business_income/confirm',
        method: 'post',
        data: params
    })
}

/**
 * 经纪确认-助理页面指派给我的商务收入数据查询
 * @param params
 * @returns {*}
 */
export function getBusinessIncomeAssistantList(params) {
    return Vue.axios({
        url: '/api/income_summary/getBsList',
        method: 'post',
        data: params
    })
}

/**
 * 经纪确认-助理页面指派给我的【全案保量】数据查询
 * @param params
 * @returns {*}
 */
export function getLiveGuaranteeList(params) {
    return Vue.axios({
        url: '/api/income_summary/getLiveGuaranteeList',
        method: 'post',
        data: params
    })
}

/**
 * 导出汇总-全案保量-经纪确认
 * @param params
 * @returns {*}
 */
export function exportLiveGuaranteeList(params) {

    return postBlob('/api/income_summary/export', params)
}

/**
 *
 * 设置经纪人助理（目的：让助理协助经纪人确认订单）
 * @param type
 * @param ids
 * @param user_aid
 * @returns {*}
 */
export function setAssistant(type, ids, user_aid) {

    return Vue.axios({
        url: '/api/income_summary/set_assistant',
        method: 'post',
        data: {type, ids, user_aid}
    })
}

/**
 * 经纪确认：统计接口
 * @param params
 * @returns {*}
 */
export function getIncomeSummaryStat(params) {

    return Vue.axios({
        url: '/api/income_summary/summaryStat',
        method: 'post',
        data: params
    })
}

